import Breadcrumbs from "@/components/Breadcrumbs";
import { SettingsService } from "@/services/admin-services";
import { SettingsPhase } from "@/services/admin-services/models";
import {
    alpha,
    Box,
    Button,
    CircularProgress,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const breadcrumbs = [
    {
        to: "../..",
        title: "Administration",
    },
    {
        title: "Settings",
        to: "../..",
    },
    {
        title: "Phases",
        to: "",
    },
];

const Overview = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<Array<SettingsPhase>>([]);

    const settingsService = new SettingsService("int");

    const theme = useTheme();
    const navigate = useNavigate();

    useEffect(() => {
        settingsService.getPhases().then((data) => {
            setData(data);
            setIsLoading(false);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderStatus = (active: boolean) => {
        let statusColor = theme.palette.success;
        if (!active) statusColor = theme.palette.error;

        return (
            <Typography
                variant={"caption"}
                fontWeight={700}
                sx={{
                    bgcolor: alpha(statusColor.light, 0.1),
                    color: statusColor.dark,
                    paddingX: 1.5,
                    paddingY: 0.5,
                    borderRadius: 4,
                    display: "inline",
                }}
            >
                {active ? "Active" : "Inactive"}
            </Typography>
        );
    };

    return (
        <Box>
            <Breadcrumbs trail={breadcrumbs} />

            <Divider />

            <Grid container spacing={2} p={{ xs: 2, md: 4 }}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 750 }} aria-label="simple table">
                            <TableHead sx={{ bgcolor: "alternate.main" }}>
                                <TableRow>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Code
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Phase
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }}>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Status
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }} />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoading ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={3}
                                            sx={{
                                                height: 400,
                                                alignItems: "center",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Box sx={{ display: "flex", placeContent: "center" }}>
                                                <CircularProgress />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    data
                                        .sort((a, b) => a.order - b.order)
                                        .map((item, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                        {item.code}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell scope="row">
                                                    <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                        {item.name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell scope="row">
                                                    <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                        {renderStatus(item.active)}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell scope="row" sx={{ p: 0 }}>
                                                    <Box sx={{ display: "flex" }}>
                                                        <Button
                                                            color={"primary"}
                                                            sx={{ ml: "auto", mr: 1 }}
                                                            onClick={() =>
                                                                navigate(`/admin/settings/phases/${item.id}`)
                                                            }
                                                        >
                                                            View
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Overview;
